import React from 'react';
import AceEditor from 'react-ace';

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-monokai";

const HtmlEditor = ({ id, onSaveText, text }) => {
  const [value, setValue] = React.useState(text);

  function onLoad(editor) {
    console.log("i've loaded");
  }

  function onChange(value) {
    setValue(
      value
    );
    onSaveText(
      id, value
    );
  }

  return (
    <div style={{ width: '100%' }}>
        <AceEditor
          placeholder="Placeholder Text"
          mode="html"
          theme="monokai"
          name="blah2"
          onLoad={onLoad}
          onChange={onChange}
          fontSize={14}
          showPrintMargin={false}
          showGutter={true}
          highlightActiveLine={true}
          value={value}
          width="100%"
          wrapEnabled={true}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
            useWorker: false,
          }} />
    </div>
  );
}

export default HtmlEditor;